import { GetQuotationModel } from "@factory/model/query-model-quotation";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { quotationFormDefault } from "./form.default";
import { QuotationFormSchema } from "./form.rule";

export const useFormDefaultQuotation = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetQuotationModel | undefined) => {
    return !cachedValue
      ? quotationFormDefault
      : ({
          adultRateTotal: cachedValue.adult_rate_total,
          childRateTotal: cachedValue.child_rate_total,
          basePackage: cachedValue.base_package,
          basePackageName: cachedValue.base_package_name,
          packageName: cachedValue.package_name,
          client: cachedValue.client,
          clientName: cachedValue.client_name,
          status: cachedValue.status,
          statusName: cachedValue.status_name,
          packageInclusions: cachedValue.package_inclusions,
          quotationDate: cachedValue.quotation_date,
          location: cachedValue.location,
          locationName: cachedValue.location_name,
          startDate: cachedValue.start_date,
          endDate: cachedValue.end_date,
          numAdults: cachedValue.num_adults,
          numChildren: cachedValue.num_children,
          numNights: cachedValue.num_nights,
          numDays: cachedValue.num_days,
          agent: cachedValue.agent,
          agentMarkup: cachedValue.agent_markup,
          amount: cachedValue.amount,
          activities: cachedValue.activities,
          transport: cachedValue.transport,
          accommodation: cachedValue.accommodation,
          hideTotal: cachedValue.hide_total,
          customRows: cachedValue.custom_rows,
          customDays: cachedValue.custom_days,
        } as QuotationFormSchema);
  };

  return {
    getDefault,
  };
};
